module.exports = __webpack_public_path__ + "zeb-96f5a41c88822fb67dc64d51c33c7337.png";